var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImprovedux(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 73,
    viewBox: "0 0 62 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3410_8626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.2928 2.21216H28.5284C23.7788 2.21216 19.9285 6.04361 19.9285 10.7699V63.3362C19.9285 68.0625 23.7788 71.894 28.5284 71.894H52.2928C57.0424 71.894 60.8928 68.0625 60.8928 63.3362V10.7699C60.8928 6.04361 57.0424 2.21216 52.2928 2.21216Z",
    fill: "white",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4595 66.0448C42.768 66.0448 44.6394 64.1633 44.6394 61.8424C44.6394 59.5215 42.768 57.64 40.4595 57.64C38.151 57.64 36.2795 59.5215 36.2795 61.8424C36.2795 64.1633 38.151 66.0448 40.4595 66.0448Z",
    fill: "#DD44B9",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 8.84851H49.8214",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5152 15.4849H0.728271V41.7974H38.5152V15.4849Z",
    fill: "white",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.72876 22.2936H32.5585",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.72876 28.6338H32.5585",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.72876 34.7471H25.2618",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3410_8626"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 73,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImprovedux);
export default __webpack_public_path__ + "static/media/improvedux.0d50f30f954f45f80ab7fede9a3ddc44.svg";
export { ForwardRef as ReactComponent };